import { useEffect, useReducer, useState } from 'react';
import { useMemo } from 'react';
import stringToNumArray from '../../../../../../utils/stringManipulation/StringToNumArray';

export const setUpOptions = {
  BOUNCE: {
    label: 'Bounce',
    key: 'BOUNCE',
  },

  BREAK: {
    label: 'Break',
    key: 'BREAK',
  },
  AD_HOC: {
    label: 'Ad Hoc',
    key: 'AD_HOC',
  },
  CONVICTION_CANDLE: {
    label: 'Conviction Candle',
    key: 'CONVICTION_CANDLE',
  },
  BOUNCE_EMA: {
    label: 'Bounce Ema',
    key: 'BOUNCE_EMA',
  },
  BREAK_EMA: {
    label: 'Break Ema',
    key: 'BREAK_EMA',
  },
  CANDLE_TRIGGER: {
    label: 'Candle Trigger',
    key: 'CANDLE_TRIGGER',
  },
  FLAG: {
    label: 'Flag',
    key: 'FLAG',
  },
  /*  FTFC: {
          label: "FTFC (The Strat)",
          key: "FTFC",
      },*/
  BREAK_CANDLE_TYPE: {
    label: 'Break Candle Type',
    key: 'BREAK_CANDLE_TYPE',
  },
  CANDLE_PATTERN: {
    label: 'Candle Pattern',
    key: 'CANDLE_PATTERN',
  },
  ORB: {
    label: 'ORB',
    key: 'ORB',
  },
};
export const useSetupFields = () => {
  const [setupFields, dispatchSetUpDetails] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      priceToBreak: 0,
      candleDuration: 1,
      minimumFirstCandleHeight: 0,
      rightColorCandle: false,
      evaluateLookBackOnStart: false,
      evaluateLookBackOnRepeat: false,
      candleClosePct: 0,
      periodLengths: [],
      timeUnit: 'MINUTES',
      permittedGapPct: -2147483648, //java # for integer.minValue
      candlesBack: 1,
      bounceOnGapFill: false,
      checkValidation: true,
      gapType: 'highLow', //highLow or openClose
      breakBy: 0.0,
      breakByOnTrigger: 0.0,
      waitUntilCurrentCandleCloses: false,
      pattern: [],
      timeFrames: [
        { candleDuration: 1, timeUnit: '' },
        { candleDuration: 1, timeUnit: '' },
        { candleDuration: 1, timeUnit: '' },
      ],
      candleColor: '',
      candleType: 'LAST',
      filterForToday: false,
    }
  );
  return [setupFields, dispatchSetUpDetails];
};

export const useSetupKey = (TOP) => {
  const [top, dispatchTop] = TOP;
  const setupKey = useMemo(
    () => (setUpOptions[top.setup] || {}).key,
    [top.setup]
  );
  return setupKey;
};

export const useSetupDetails = (TOP, setup_key, setup_fields) => {
  const [top, dispatchTop] = TOP;
  const setupKey = setup_key;
  const [setupFields, dispatchSetUpDetails] = setup_fields;
  const setupDetails = useMemo(() => {
    switch (top.setup) {
      case 'BREAK':
      case 'BOUNCE':
        dispatchTop({ strategy: 'BASIC_TRADING_SYSTEM' });
        return {
          [setupKey]: {
            priceToBreak: parseFloat(setupFields.priceToBreak),
          },
        };
      case 'AD_HOC':
        dispatchTop({ strategy: 'BASIC_TRADING_SYSTEM' });
        return {
          [setupKey]: {},
        };
      case 'CONVICTION_CANDLE':
        dispatchTop({ strategy: 'BASIC_TRADING_SYSTEM' });
        return {
          [setupKey]: {
            candleDuration: parseFloat(setupFields.candleDuration),
            minimumFirstCandleHeight: parseFloat(
              setupFields.minimumFirstCandleHeight
            ),
            rightColorCandle: setupFields.rightColorCandle,
            candleClosePct: parseFloat(setupFields.candleClosePct),
            permittedGapPct: parseFloat(setupFields.permittedGapPct),
          },
        };
      case 'CANDLE_TRIGGER':
        dispatchTop({ strategy: 'BASIC_TRADING_SYSTEM' });
        return {
          [setupKey]: {
            candlesBack: parseInt(setupFields.candlesBack),
            timeUnit: setupFields.timeUnit,
            candleDuration: setupFields.candleDuration,
            checkValidation: setupFields.checkValidation,
            breakBy: setupFields.breakBy,
            bounceOnGapFill: setupFields.bounceOnGapFill,
            gapType: setupFields.gapType,
          },
        };
      case 'BOUNCE_EMA':
      case 'BREAK_EMA':
        dispatchTop({ strategy: 'RELATED_TRADING_SYSTEMS' });
        return {
          [setupKey]: {
            candleDuration: parseFloat(setupFields.candleDuration),
            timeUnit: setupFields.timeUnit,
            periodLengths: stringToNumArray(setupFields.periodLengths),
          },
        };
      case 'FLAG':
        dispatchTop({ strategy: 'BASIC_TRADING_SYSTEM' });
        return {
          [setupKey]: {
            waitUntilCurrentCandleCloses:
              setupFields.waitUntilCurrentCandleCloses,
            candleDuration: setupFields.candleDuration,
            breakBy: setupFields.breakBy,
            pattern: setupFields.pattern,
          },
        };
      case 'CANDLE_PATTERN':
        dispatchTop({ strategy: 'BASIC_TRADING_SYSTEM' });
        return {
          [setupKey]: {
            waitUntilCurrentCandleCloses:
              setupFields.waitUntilCurrentCandleCloses,
            candleDuration: setupFields.candleDuration,
            //breakBy: setupFields.breakBy,
            breakByOnTrigger: setupFields.breakByOnTrigger,
            pattern: setupFields.pattern,
            evaluateLookBackOnStart: setupFields.evaluateLookBackOnStart,
            evaluateLookBackOnRepeat: setupFields.evaluateLookBackOnRepeat,
          },
        };
      case 'FTFC':
        dispatchTop({ strategy: 'BASIC_TRADING_SYSTEM' });
        return {
          [setupKey]: {
            timeFrames: setupFields.timeFrames,
          },
        };
      case 'ORB':
        dispatchTop({ strategy: 'BASIC_TRADING_SYSTEM' });
        return {
          [setupKey]: {
            candleDuration: setupFields.candleDuration,
            breakBy: setupFields.breakBy,
          },
        };
      case 'BREAK_CANDLE_TYPE':
        dispatchTop({ strategy: 'BASIC_TRADING_SYSTEM' });
        return {
          [setupKey]: {
            candleDuration: setupFields.candleDuration,
            breakBy: setupFields.breakBy,
            candleColor: setupFields.candleColor,
            candleType: setupFields.candleType,
            filterForToday: setupFields.filterForToday,
          },
        };
      default:
    }
  }, [top.setup, setupKey, ...Object.values(setupFields)]);
  return setupDetails;
};

export const useBreak = () => {
  const [Break, dispatchBreak] = useReducer(
    (data, action) => ({ ...data, ...action }),
    { priceToBreak: 0 }
  );
  return [Break, dispatchBreak];
};

export const useBreakEnabled = () => {
  const [breakEnabled, setBreakEnabled] = useState(false);
  return [breakEnabled, setBreakEnabled];
};
